import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import SingleColCellRenderer, { AssignToolItemType, AssignToolRightBox, ShowTypeValues, cvAssignmentToolWarnings } from './angular-assign-tool.models';
import { AngularAssignToolService } from '../angular-assign-tool.service';
import { GroupTypeDTO } from 'src/AngularJS/Admin/Company/company.model';
import { CVLocalizationService } from '../../services/cv-localization.service';
import { AgGridHelperService } from '../../services/ag-grid-helper.service';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { ObjectiveAssignComponent } from 'src/app/admin/objectives/objective-assign/objective-assign.component';
import { AgGridAngular } from 'ag-grid-angular';
import { BroadcastAssignComponent } from '../../broadcasts/broadcast-assign/broadcast-assign.component';
import { cloneDeep } from 'lodash';
import { ColDef } from 'ag-grid-community';
import { GameType } from 'src/app/dashboard/modals/cxone-award-modal/cxone-award.model';

@Component({
    selector: 'cv-angular-assign-tool',
    templateUrl: './angular-assign-tool.component.html',
    styleUrls: ['./angular-assign-tool.component.scss']
})
export class AngularAssignToolComponent implements OnInit, OnChanges, AfterViewInit {
    @Input() showAll = true;
    @Input() singleAdd = true;
    @Input() singleType = true;
    @Input() showParent = false;
    @Input() type = "";
    @Input() headerText = "";
    @Input() buttonText = "";
    @Input() showPopup = true;
    @Input() dataTransfer;
    @Input() useLogins = false;
    @Input() retainSelected = true;
    @Input() showTypes = "";
    @Input() dataOptions;
    @Input() limitOfParticipants: number = null;
    @Input() gameType: number;

    @Output() applied = new EventEmitter();
    @Output() dataTransferChange = new EventEmitter();
    @Output() showPopupChange = new EventEmitter<boolean>();
    @Output() singleRowSelected: EventEmitter<any> = new EventEmitter<any>();
    @Output() wallboardAssignmentUpdateLanding = new EventEmitter<any>();
    @Output() SavePermissionGroupEvent = new EventEmitter<any[]>();
    @Output() WallboardAssignmentUpdateLandingEvt = new EventEmitter<any>();
    @Output() SaveBroadcastEvent = new EventEmitter<any[]>();

    // Once right hand boxes are created, add @viewChild component so they can get the events
    @ViewChild(ObjectiveAssignComponent) objectiveComponent: ObjectiveAssignComponent;
    @ViewChild(BroadcastAssignComponent) broadcastAssignComponent: BroadcastAssignComponent;

    @ViewChild('assignToolGrid') agGrid: AgGridAngular;
    @ViewChild(AssignToolRightBox) rightBoxComponent: AssignToolRightBox;

    daWarnings: cvAssignmentToolWarnings = {
        showTemplateWarning: false,
        showWriteWarning: false,
        showReadControlWarning: false
    };
    isDataLoading = false;
    showEmpGroupNames = false; // Drill down toggle
    empGroupTypes: GroupTypeDTO[] = []; // Groups in the left drilldown
    showRecGroupNames = false; // Drill down toggle
    recGroupTypes: GroupTypeDTO[] = []; // Groups in the left drilldown
    selectedType = ""; // String type ie 'emp', 'rec' that is currently selected (later will include attribute, login etc)
    selectedLabel = ""; // Used for the table header ie 'Team'
    selectedLevel = 0; // Selected group level int 0 should work for other types
    selectedList: any[] = []; // This list is populated with the groups contained in the the selected group type ie Companies in Company Level
    assignList: any[] = []; // This is the list used by the third box of the assign tool selected out of the middle.
    showAttrGroupNames = false;
    attributes: any[] = []; // Left box attribute list
    selectedParentOption: number = null; // Level value for the parent dropdown, used to know which index of the parent path to use
    isCheckedAll = false; // Used by the header checkbox to be checked if all others are checked
    popupButtonEnabled = true;
    filterText = ""; // Search box value
    retainList: any[] = []; // Used if retain selected is true to allow the assignList to be restored on cancel or "edit" cases
    disableContainers = false; // Used to disable the left and mid containers (add an overlay)
    moreOptions = false;
    localizationDic: Map<string, string>;
    assignToolTable: any = {
        filterText: ""
    };
    activeSingleSelection = null;

    showTypeValues: ShowTypeValues = {
        emp: true,
        rec: true,
        agent_att: false,
        empAssignAll: false,
        recAssignAll: false
    };
    selectedParticipants = [];

    noRowsTemplate = '';
    localizedButtonText = '';

    constructor(
        private assignToolService: AngularAssignToolService,
        private localization: CVLocalizationService,
        private agGridHelperService: AgGridHelperService,
        private navigationService: NavigationService
    ) { }

    async ngOnInit() {
        if (this.showTypes != null && this.showTypes !== "" && this.showTypes.length > 0) {
            this.showTypes = this.showTypes.toLowerCase();
            this.showTypeValues.empAssignAll = this.showTypes.indexOf('e_assign_all') > -1 ? true : false;
            this.showTypeValues.recAssignAll = this.showTypes.indexOf('r_assign_all') > -1 ? true : false;
            this.showTypeValues.emp = this.showTypes.indexOf('emp') > -1 ? true : false;
            this.showTypeValues.rec = this.showTypes.indexOf('rec') > -1 ? true : false;
            this.showTypeValues.agent_att = this.showTypes.indexOf('agent_att') > -1 ? true : false;
        }

        // Load the left box items
        const result = await this.assignToolService.loadGroupTypes();
        await this.localization.GetSection("Common");

        this.empGroupTypes = cloneDeep(result.EmpGroupTypes);
        this.recGroupTypes = cloneDeep(result.RecGroupTypes);
        if (this.limitOfParticipants !== null) { //if there is a maximum limit of participants, this will be validated.
            this.empGroupTypes = this.empGroupTypes.filter(item => item.GroupLevel === 1);
        }
        if (this.showTypeValues.agent_att) {
            const attribute_result = await this.assignToolService.loadAttributes();
            this.attributes = cloneDeep(attribute_result);
        }
        this.localizationDic = await this.localization.GetSection("Assign_Tool");

        switch (this.buttonText) {
            case 'Apply':
                this.localizedButtonText = this.localization.getCachedText("Common", "Apply", this.buttonText);
                break;
            case 'Assign':
                this.localizedButtonText = this.localization.getCachedText("Assign_Tool", "Assign", this.buttonText);
                break;
            case 'Save':
                this.localizedButtonText = this.localization.getCachedText("Common", "Save_Button", this.buttonText);
                break;
            default:
                this.localizedButtonText = this.buttonText;
        }

        this.setupGrid();
        this.noRowsTemplate = this.overlayNoRowsTemplate();
    }

    ngAfterViewInit() {
        if (this.assignList.length == 0) {
            if (this.objectiveComponent != null)
                this.objectiveComponent.AssignToolUpdateObjectiveEvt();
        }
    }

    get showRecGroups(): boolean {
        return this.showTypeValues.rec && this.gameType !== GameType.BracketTournament;
    }

    public checkNodeHasToBeExcluded(node) {
        let hasToBeExcluded = false;
        if (node.data.ID < this.selectedList.length) {
            // Get node from selectedList by position
            const nodeByPosition = this.selectedList[node.data.ID];
            // Check if node exits on assignList
            if (nodeByPosition) {
                hasToBeExcluded = this.assignList.filter((item: any) => {
                    return (item.GroupID == nodeByPosition.groupDTO.GroupID &&
                        item.GroupLevel == nodeByPosition.groupDTO.GroupLevel &&
                        item.BaseGroupType == nodeByPosition.groupDTO.BaseGroupType);
                }).length > 0;
            }
        }
        return hasToBeExcluded;
    }

    public overlayNoRowsTemplate() {
        const localizationMessage = [...this.localizationDic].find(([key, val]) => key == `Sorry_No_Data_Found`);
        const message = localizationMessage?.[1] ?? 'Sorry, no data was found';

        return `<h7 class="px-5 font-weight-bold">${message}</h7>`;
    }

    /**
     * Drilldown handler function
     * @param str
     */
    public drillLists(str) {
        if (str == null)
            return;

        switch (str) {
            case 'rec':
                this.showRecGroupNames = !this.showRecGroupNames;
                break;
            case 'emp':
                this.showEmpGroupNames = !this.showEmpGroupNames;
                break;
            case 'attr':
                this.showAttrGroupNames = !this.showAttrGroupNames;
                break;
        }
    }

    /**
     * Hides the popup then allows scrolling again
     * */
    public closeClick() {
        this.assignToolTable.filterText = "";
        if (this.type == "broadcast") {
            this.retainList = cloneDeep(this.assignList);
            this.broadcastAssignComponent.reset();
        }
        this.showPopup = false;
        this.showPopupChange.emit(this.showPopup);
        this.resetPopup();

        this.daWarnings = {
            showTemplateWarning: false,
            showWriteWarning: false,
            showReadControlWarning: false
        };

        $("body").removeClass("cvGSstopScrolling");
        this.navigationService.showOverlay = false;

        if (this.assignList.length === 0) {
            this.selectedParticipants = [];
        }
    }

    /**
     * Security function for left box
     * @param str
     * @param level
     */
    public typeIsDisabled(str, level) {
        for (let assignItem of this.assignList) {
            if (str == 'emp') {
                if (assignItem.BaseGroupType == 0 && level != assignItem.GroupLevel)
                    return true;
            }
            else if (str == 'rec') {
                if (assignItem.BaseGroupType == 1 && level != assignItem.GroupLevel)
                    return true;
            }
        }
        if (this.type == 'objectives' || this.type == 'gamesAddEdit' || this.type == "awardsAddEdit") {
            if (this.dataOptions != null && this.dataOptions.coreAssignAtOption == 'parent') {
                if ((this.dataOptions.coreAssignAtType == str && this.dataOptions.coreAssignAtLevel >= level))
                    return true;
            }
            else if (this.dataOptions != null && this.dataOptions.coreAssignAtOption == 'specific') {
                if ((this.dataOptions.coreAssignAtType == str && this.dataOptions.coreAssignAtLevel != level))
                    return true;
            }
        }

        return false;
    }

    public async popupButtonClick() {
        if (this.daWarnings.showTemplateWarning || this.daWarnings.showWriteWarning || this.daWarnings.showReadControlWarning)
            return;

        await this.rightBoxComponent?.apply();

        // Updates the list assigned to datatransfer on the other end
        if (this.type == "dashboardSharing")
            this.dataTransferChange.emit(this.dataTransfer);
        else {
            this.dataTransfer = angular.copy(this.assignList);
            this.dataTransferChange.emit(this.dataTransfer);
        }

        if (this.type == "permission assignments")
            this.SavePermissionGroupEvent.emit(this.assignList);
        else if (this.type == 'objectives')
            this.objectiveComponent.AssignToolButtonEvt();
        else if (this.type == "broadcast") {
            this.SaveBroadcastEvent.emit(this.assignList);
            this.retainList = cloneDeep(this.assignList);
        }

        this.closeClick();
        this.applied.emit();
    }

    public resetPopup() {
        this.isDataLoading = false;
        this.showEmpGroupNames = false;
        this.showRecGroupNames = false;
        this.showAttrGroupNames = false;
        this.selectedType = "";
        this.selectedLabel = "";
        this.selectedLevel = 0;
        this.selectedList = [];
        this.assignList = [];
        this.selectedParentOption = null;
        this.isCheckedAll = false;
        this.filterText = "";
        this.assignToolTable.centerTable.rowData = [];
        this.disableContainers = false;

        this.assignToolTable.updateParentCol(); // Initially hides the parent column as nothing is selected in the dropdown

        this.rightBoxComponent?.resetPopup();
    }

    public getLoginsFunction() {
        if (this.type == 'budget') {
            const groupLevel = this.dataOptions ? this.dataOptions.groupLevel : null;
            const groupType = this.dataOptions ? this.dataOptions.groupType : null;
            const groupID = this.dataOptions ? this.dataOptions.groupID : null;

            return this.assignToolService.loadLoginsByParentGroup(groupLevel, groupType, groupID);
        }
        else
            return this.assignToolService.loadLogins(null, null, null, null);
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.showPopup != null) {
            if (changes.showPopup.currentValue) {
                $("body").addClass("cvGSstopScrolling");
                this.navigationService.showOverlay = true;

                if (this.retainSelected)
                    this.assignList = angular.copy(this.retainList);

                switch (this.type) {
                    case "budget":
                    case "gamesAddEdit":
                    case "forms":
                    case "awardsAddEdit":
                    case "permission assignments":
                        this.assignList = angular.copy(this.dataTransfer);
                        break;
                    case "broadcast":
                        if (this.retainSelected && this.retainList?.length > 0) {
                            this.assignList = angular.copy(this.retainList);
                        }
                        else this.assignList = angular.copy(this.dataTransfer);
                        break;
                }

                //$scope.$broadcast("showPopup");
            }
        }

        if (changes.dataTransfer != null) {
            if (this.type != 'objectives' && this.type != 'marketplace' && this.type != 'metricDefinition' && this.type != "wallboards" && this.type != "broadcast")
                return;

            this.assignList = [];

            if (this.dataTransfer && this.dataTransfer.emp != null) {
                for (let empGroup of this.dataTransfer.emp) {
                    this.assignList.push(angular.copy(empGroup));
                    requestAnimationFrame(() => { this.rightBoxComponent?.onAssignToolGroupCountEvent(empGroup); });
                }
            }

            if (this.dataTransfer && this.dataTransfer.rec != null) {
                for (let recGroup of this.dataTransfer.rec) {
                    this.assignList.push(angular.copy(recGroup));

                    requestAnimationFrame(() => { this.rightBoxComponent?.onAssignToolGroupCountEvent(recGroup); });
                }
            }

            if (this.dataTransfer && this.dataTransfer.attr != null) {
                for (let attribute of this.dataTransfer.attr) {
                    this.assignList.push(angular.copy(attribute));
                }
            }

            if (this.assignList.length == 0) {
                if (this.objectiveComponent != null)
                    this.rightBoxComponent?.onAssignToolNoData();
            }

            // broadcast
            if (this.type == "broadcast"
                && this.dataTransfer) {
                if (this.retainSelected && this.retainList.length > 0) this.assignList = angular.copy(this.retainList);
                else this.assignList = angular.copy(this.dataTransfer);
            }

            this.retainList = angular.copy(this.assignList);
        }

        if (changes.showTypes?.isFirstChange())
            this.initializeTypes();
    }

    async initializeTypes() {
        if (this.showTypes != null && this.showTypes !== "" && this.showTypes.length > 0) {
            this.showTypes = this.showTypes.toLowerCase();
            this.showTypeValues.emp = this.showTypes.indexOf('emp') > -1 ? true : false;
            this.showTypeValues.rec = this.showTypes.indexOf('rec') > -1 ? true : false;
            this.showTypeValues.agent_att = this.showTypes.indexOf('agent_att') > -1 ? true : false;
        }

        if (this.showTypeValues.agent_att) {
            const attribute_result = await this.assignToolService.loadAttributes();
            this.attributes = angular.copy(attribute_result);
            if (this.attributes.length === 0)
                this.showTypeValues.agent_att = false;
        }
    }

    setupGrid() {
        this.assignToolTable = {
            data: [],
            gridApi: null,
            filterText: "",
            centerTable: this.agGridHelperService.createGridOptions({
                columnDefs: [],
                rowData: [],

                rowSelection: 'multiple',
                rowMultiSelectWithClick: false,

                suppressRowClickSelection: true,
                suppressCellFocus: true,
                suppressContextMenu: true,

                headerHeight: 0,
                defaultColDef: {
                    sortable: false,
                    filter: true,
                    resizable: false,
                    suppressMovable: true,
                    suppressMenu: true
                },

                components: {
                    singleColCellRenderer: SingleColCellRenderer,
                },
                context: {
                    addClicked: () => this.moreOptions = true,
                },
                onGridReady: params => {
                    params.api.sizeColumnsToFit();
                },
                getRowId: ({ data: rowData }) => rowData.ID,
                onCellClicked: event => {
                    let data;

                    if (this.moreOptions && !this.isDataLoading) {
                        data = event.node.data;
                        data.entity = {};
                        data.entity.ID = {};
                        data.entity.ID = data.ID;

                        switch (event.column.getUserProvidedColDef().field) {
                            case "Parent":
                            case "Group":
                            case "Attribute":
                            case "LoginName":
                                this.assignToolTable.singleAssign(data);

                                this.assignToolTable.updateColumnDefs();
                                this.assignToolTable.updateGridFilter();

                                break;
                            case "chkbox":
                                this.assignToolTable.multiAssign(data);

                                this.assignToolTable.updateColumnDefs();
                                this.assignToolTable.updateGridFilter();
                                break;
                        }
                        this.moreOptions = false;
                    }

                    if (!this.singleAdd) {
                        data = event.node.data;

                        this.agGrid.api.applyTransaction(data);
                        if (this.type !== "gamesAddEdit" && this.type !== "awardsAddEdit") {
                            $(event.event.target).find("input").prop("checked", true); // Update radio button
                        }
                    }
                },
                onGridSizeChanged: (e) => {
                    e.api.sizeColumnsToFit();
                },
                overlayNoRowsTemplate: this.overlayNoRowsTemplate(),
                animateRows: true,
                rowHeight: 40,
                isExternalFilterPresent: () => true,

                doesExternalFilterPass: node => {
                    const tmpFilter = this.assignToolTable.filterText.toUpperCase();
                    if (tmpFilter === "")
                        return true;

                    switch (this.selectedType) {
                        case "emp":
                        case "rec":
                        case "attr":
                            if (this.assignList.length !== 0) {
                                const tempAgAssignList = this.assignList.filter(item => (
                                    (item.AttributeValueName && item.AttributeValueName === node.data.Group) ||
                                    (item.GroupName && item.GroupName === node.data.Group)
                                ))[0];

                                let hasToBeExcluded = false;
                                if (tempAgAssignList)
                                    hasToBeExcluded = this.checkNodeHasToBeExcluded(node);

                                if (hasToBeExcluded) {
                                    const filter = tempAgAssignList.AttributeValueName || tempAgAssignList.GroupName;

                                    return ((node.data.Group && node.data.Group.toUpperCase().includes(tmpFilter)) &&
                                        !(node.data.Group && node.data.Group.toUpperCase().includes(filter.toUpperCase()))
                                    );
                                }
                            }
                            return ((node.data.Group && node.data.Group.toUpperCase().includes(tmpFilter)));
                        case "login":
                            if (this.assignList.length !== 0) {
                                const tempAgAssignList = this.assignList.filter((item) => (
                                    !!item.LoginName && item.LoginName === node.data.LoginName
                                ))[0];

                                if (tempAgAssignList != null) {
                                    const filter = tempAgAssignList.AttributeValueName || tempAgAssignList.GroupName;

                                    return ((node.data.Group && node.data.Group.toUpperCase().includes(tmpFilter)) &&
                                        !(node.data.Group && node.data.Group.toUpperCase().includes(filter.toUpperCase()))
                                    );
                                }
                            }
                            return ((node.data.LoginName && node.data.LoginName.toUpperCase().includes(tmpFilter)));
                    }
                    return true;
                },
                popupParent: document.body,
                alwaysShowVerticalScroll: true,

                enableRangeSelection: true,
            }),

            clearTable: updateColumnDefs => {
                if (updateColumnDefs === undefined || updateColumnDefs === null)
                    updateColumnDefs = false;

                this.assignToolTable.centerTable.rowData = [];
                if (updateColumnDefs)
                    this.assignToolTable.updateColumnDefs();
            },

            getDataList: (type: AssignToolItemType, level: number, label: string) => {
                if (this.isDataLoading)
                    return; // Data load already in progress so dont start another one
                if (this.singleType && this.typeIsDisabled(type, level))
                    return; // If singleType is selected and items are in the list then the base data set cannot be changed.
                if (this.selectedType === type && this.selectedLevel === level)
                    return; // This group is already selected

                this.selectedParentOption = null;
                this.selectedType = type;
                this.selectedLevel = level;
                this.selectedLabel = label;

                // Calls based on type
                switch (type) {
                    case AssignToolItemType.EmpGroup:
                        this.isDataLoading = true;
                        this.assignToolService.loadEmpGroups(level).then((result) => {
                            this.isDataLoading = false;
                            this.selectedList = cloneDeep(result);
                            this.isCheckedAll = false;

                            this.assignToolTable.clearTable(true); // Clears the old data out of the table
                            this.assignToolTable.data = [];

                            for (let i = 0; i < this.selectedList.length; i++) {
                                let newRow;
                                if (!this.singleAdd) {
                                    newRow = {
                                        chkbox: '',
                                        ID: i,
                                        GroupID: this.selectedList[i].groupDTO.GroupID,
                                        Group: this.selectedList[i].groupDTO.GroupName,
                                        Parent: this.selectedList[i].parentPath,
                                        singleSelect: '',
                                        BaseGroup: 0,
                                    };
                                }
                                else {
                                    newRow = {
                                        chkbox: '',
                                        ID: this.selectedList[i].groupDTO.GroupID as number,
                                        GroupID: this.selectedList[i].groupDTO.GroupID,
                                        Group: this.selectedList[i].groupDTO.GroupName,
                                        Parent: this.selectedList[i].parentPath,
                                        singleSelect: '',
                                        BaseGroup: 0,
                                    };
                                }

                                this.assignToolTable.data.push(newRow);
                            }

                            this.assignToolTable.centerTable.rowData = cloneDeep(this.assignToolTable.data);
                            this.assignToolTable.updateColumnDefs();
                            this.assignToolTable.updateGridFilter();

                            window.setTimeout(() => {
                                this.assignToolTable.checkHideRows(this.selectedType, this.selectedLevel); // Checks if any rows need to be hidden due to being previously selected ie. selecting items then switching levels then coming back
                            }, 0);

                            this.assignToolTable.updateRowData();
                        });
                        break;
                    case AssignToolItemType.RecGroup:
                        this.isDataLoading = true;
                        this.assignToolService.loadRecGroups(level).then((result) => {
                            this.isDataLoading = false;
                            this.selectedList = cloneDeep(result);
                            this.isCheckedAll = false;

                            this.assignToolTable.clearTable(true); // Clears the old data out of the table
                            this.assignToolTable.data = [];

                            for (let i = 0; i < this.selectedList.length; i++) {
                                let newRow;
                                if (!this.singleAdd)
                                    newRow = {
                                        chkbox: '',
                                        ID: i,
                                        GroupID: this.selectedList[i].groupDTO.GroupID,
                                        Group: this.selectedList[i].groupDTO.GroupName,
                                        Parent: this.selectedList[i].parentPath,
                                        BaseGroup: 1,
                                        singleSelect: ''
                                    };
                                else
                                    newRow = {
                                        chkbox: '',
                                        ID: this.selectedList[i].groupDTO.GroupID as number,
                                        GroupID: this.selectedList[i].groupDTO.GroupID,
                                        Group: this.selectedList[i].groupDTO.GroupName,
                                        Parent: this.selectedList[i].parentPath,
                                        BaseGroup: 1,
                                        singleSelect: ''
                                    };

                                this.assignToolTable.data.push(newRow);
                            }

                            this.assignToolTable.centerTable.rowData = cloneDeep(this.assignToolTable.data);
                            this.assignToolTable.updateColumnDefs();
                            this.assignToolTable.updateGridFilter();

                            window.setTimeout(() => {
                                this.assignToolTable.checkHideRows(this.selectedType, this.selectedLevel); // Checks if any rows need to be hidden due to being previously selected ie. selecting items then switching levels then coming back
                            }, 0);

                            this.assignToolTable.updateRowData();
                        });
                        break;
                    case AssignToolItemType.Attribute:
                        this.isDataLoading = true;
                        this.assignToolService.loadAttributeValues(level).then((result) => {
                            this.isDataLoading = false;
                            this.selectedList = cloneDeep(result);
                            this.isCheckedAll = false;

                            this.assignToolTable.clearTable(true); // Clears the old data out of the table
                            this.assignToolTable.data = [];

                            for (let i = 0; i < this.selectedList.length; i++) {
                                let newRow;
                                if (!this.singleAdd)
                                    newRow = {
                                        chkbox: '',
                                        ID: i,
                                        Group: this.selectedList[i].AttributeValueName,
                                        GroupID: this.selectedList[i].AttributeValueID,
                                        Parent: '',
                                        singleSelect: ''
                                    };
                                else
                                    newRow = {
                                        chkbox: '',
                                        ID: this.selectedList[i].AttributeValueID,
                                        GroupID: this.selectedList[i].AttributeValueID,
                                        Group: this.selectedList[i].AttributeValueName,
                                        Parent: '',
                                        singleSelect: ''
                                    };

                                this.assignToolTable.data.push(newRow);
                            }

                            this.assignToolTable.centerTable.rowData = cloneDeep(this.assignToolTable.data);
                            this.assignToolTable.updateColumnDefs();
                            this.assignToolTable.updateGridFilter();

                            window.setTimeout(() => {
                                this.assignToolTable.checkHideRows(this.selectedType, this.selectedLevel); // Checks if any rows need to be hidden due to being previously selected ie. selecting items then switching levels then coming back
                            }, 0);

                            this.assignToolTable.updateRowData();
                        });
                        break;
                    case AssignToolItemType.Login:
                        this.isDataLoading = true;

                        this.getLoginsFunction().then((result) => {
                            this.isDataLoading = false;
                            this.selectedList = cloneDeep(result);
                            this.isCheckedAll = false;

                            this.assignToolTable.clearTable(true); // Clear old data out of the table
                            this.assignToolTable.data = [];

                            for (let i = 0; i < this.selectedList.length; i++) {
                                let newRow;
                                if (!this.singleAdd)
                                    newRow = {
                                        chkbox: '',
                                        ID: i,
                                        LoginName: this.selectedList[i].LoginName,
                                        Parent: '',
                                        singleSelect: ''
                                    };
                                else
                                    newRow = {
                                        chkbox: '',
                                        ID: this.selectedList[i].LoginID as number,
                                        LoginName: this.selectedList[i].LoginName,
                                        Parent: '',
                                        singleSelect: ''
                                    };

                                this.assignToolTable.data.push(newRow);
                            }

                            this.assignToolTable.centerTable.rowData = cloneDeep(this.assignToolTable.data);

                            this.assignToolTable.updateColumnDefs();
                            this.assignToolTable.updateGridFilter();

                            window.setTimeout(() => {
                                this.assignToolTable.checkHideRows(this.selectedType, this.selectedLevel); // Checks if any rows need to be hidden due to being previously selected, i.e. selecting items then switching levels then coming back
                            }, 0);

                            this.assignToolTable.updateRowData();
                        });
                        this.assignToolTable.updateRowData();
                        break;
                }

                this.assignToolTable.updateRowData();
                //$scope.$broadcast("assignLevelOrTypeChanged", type, level); //when right hand boxes are created then convert this to call the function on the viewChild (wallboard, dashboard, broadcast)
                this.rightBoxComponent?.onAssignLevelOrTypeChanged(type, level);
            },

            updateColumnDefs: () => {
                if (this?.agGrid?.api)
                    this.agGrid.api.setGridOption('columnDefs', this.assignToolTable.setColumnDefs(true));
            },

            setColumnDefs: (useSelectedType: boolean) => {
                return ((this.selectedParentOption == null) ? this.assignToolTable.getSingleColumns(useSelectedType) : this.assignToolTable.getMultiColumns(useSelectedType));
            },

            getSingleColumns: (useSelectedType = false): ColDef[] => {
                if (useSelectedType === undefined || useSelectedType === null) useSelectedType = false;

                const multiSelectGroupDef = [{
                    field: "chkbox",
                    headerName: '',
                    width: 350,
                    cellRenderer: (params) => {
                        const div = document.createElement('div');
                        div.className = "d-flex flex-row checkbox align-items-center h-100 pl-4";

                        const input = document.createElement('input');
                        input.id = "chk_" + params.data.GroupID;
                        input.type = "checkbox";
                        input.checked = !!params.data.chkbox;
                        input.className = "form-check-input mb-1";

                        if (this.limitOfParticipants !== null) {
                            if (this.assignList.length > 0 && this.selectedParticipants.length === 0) {
                                this.selectedParticipants.push(...this.assignList);
                            }
                            if (this.assignList.length >= this.limitOfParticipants ||
                                this.selectedParticipants.length >= this.limitOfParticipants)
                                input.disabled = !params.data.chkbox;
                        }

                        input.addEventListener('click', (event) => {
                            params.value = !params.value;
                            params.node.data.chkbox = params.value;

                            if (params.value) {
                                if (!this.selectedParticipants.some(item => item.GroupID === params.node.data.GroupID)) {
                                    this.selectedParticipants.push(params.node.data);
                                }
                            } else {
                                this.selectedParticipants = this.selectedParticipants.filter(item =>
                                    item.GroupID !== params.node.data.GroupID);
                            }

                            if (this.limitOfParticipants !== null) {
                                const itemsToUpdate = [];

                                for (let displayRow of this.agGrid.api['rowModel'].rowsToDisplay) {
                                    const data = displayRow.data;

                                    data.toAssign = !!data.chkbox;
                                    data.disabled = this.selectedParticipants.length >= this.limitOfParticipants && !data.chkbox;

                                    itemsToUpdate.push(data);
                                }

                                this.assignToolTable.centerTable.rowData = this.assignToolTable.centerTable.rowData.map(item => {
                                    const updatedItem = itemsToUpdate.find(updated => updated.GroupID === item.GroupID);
                                    return updatedItem ? { ...item, ...updatedItem } : item;
                                });

                                this.agGrid.api.applyTransaction({ update: itemsToUpdate });
                                this.agGrid.api.refreshCells({ force: true });
                            }

                            this.moreOptions = true;
                        });

                        const label = document.createElement('label');
                        label.textContent = this.selectedType === 'login' ? params.data.LoginName : params.data.Group;
                        label.className = "form-check-label ml-2 color-whaleTail w-100";
                        label.setAttribute("for", "chk_" + params.data.GroupID);

                        div.append(input);
                        div.append(label);
                        return div;
                    }
                }];

                const singleSelectGroupDef = [{ field: "Group", headerName: '', cellRenderer: 'singleColCellRenderer', width: 350 }];
                const singleSelectLoginDef = [{ field: "LoginName", headerName: '', cellRenderer: 'singleColCellRenderer', width: 350 }];

                if (!this.singleAdd)
                    return multiSelectGroupDef;
                else {
                    if (useSelectedType && this.selectedType === 'login')
                        return singleSelectLoginDef;
                    return singleSelectGroupDef;
                }
            },

            getMultiColumns: (useSelectedType: boolean): ColDef[] => {
                if (useSelectedType === undefined || useSelectedType === null) useSelectedType = false;

                const multiSelectGroupDef: any = [{
                    field: "chkbox", headerName: '', width: 175, cellRenderer: (params) => {
                        const label = document.createElement('label');
                        label.textContent = this.selectedType === 'login' ? params.data.LoginName : params.data.Group;
                        label.className = "w-100 h-100";

                        const input = document.createElement('input');
                        input.type = "checkbox";
                        input.checked = !!params.data.chkbox;

                        input.addEventListener('click', (event) => {
                            params.value = !params.value;
                            params.node.data.chkbox = params.value;
                            this.moreOptions = true;
                        });
                        label.prepend(input);
                        return label;
                    }
                }];

                const singleSelectGroupDef = [{ field: "Group", headerName: '', width: 175 }];
                const singleSelectLoginDef = [{ field: "LoginName", headerName: '', cellRenderer: 'singleColCellRenderer', width: 350 }];
                let agColumn;

                switch (this.selectedType) {
                    case 'emp':
                        agColumn = {
                            field: "Parent",
                            headerName: '',
                            width: 200,
                            cellRenderer: (!this.singleAdd ? '' : 'singleColCellRenderer'),
                            valueGetter: (params) => {
                                let parent = '';
                                for (let i = 0; i < this.empGroupTypes.length; i++) {
                                    if (this.empGroupTypes[i].GroupLevel === this.selectedParentOption) {
                                        parent = params.data.Parent[i];
                                        break;
                                    }
                                }

                                return parent;
                            },
                        };
                        if (this.singleAdd)
                            singleSelectGroupDef.push(agColumn);
                        else
                            multiSelectGroupDef.push(agColumn);

                        break;
                    case 'rec':
                        agColumn = {
                            field: "Parent", headerName: '',
                            width: 200,
                            cellRenderer: (!this.singleAdd ? '' : 'singleColCellRenderer'),
                            valueGetter: (params) => {
                                let parent = '';
                                for (let i = 0; i < this.recGroupTypes.length; i++) {
                                    if (this.recGroupTypes[i].GroupLevel === this.selectedParentOption) {
                                        parent = params.data.Parent[i];
                                        break;
                                    }
                                }

                                return parent;
                            },
                        };
                        if (this.singleAdd)
                            singleSelectGroupDef.push(agColumn);
                        else
                            multiSelectGroupDef.push(agColumn);

                        break;
                }

                if (!this.singleAdd) {
                    return multiSelectGroupDef;
                } else {
                    if (useSelectedType && this.selectedType === 'login')
                        return singleSelectLoginDef;
                    return singleSelectGroupDef;
                }
            },

            show: () => {
                this.assignToolTable.loadLogins();
                this.assignToolTable.isVisible = true;
            },

            checkHideRows: (type, level) => {
                this.assignToolTable.updateColumnDefs();
                this.assignToolTable.updateGridFilter();
            },

            isItemsSelected: () => {
                if (this.assignToolTable.centerTable.rowData == null)
                    return false;

                if (!this.agGrid?.api)
                    return false;

                for (const displayRow of this.agGrid.api['rowModel'].rowsToDisplay) {
                    if (displayRow.data.toAssign)
                        return true;
                }
                return false;
            },

            addSelected: () => {
                if (this.disableContainers) return;

                // Looping through row data instead of displayed rows this way we take away the groups already assigned by their GroupID and not ROWID 
                for (const row of this.assignToolTable.centerTable.rowData) {
                    if (row.toAssign) {
                        const rowId = row.GroupID;
                        const baseGroup = row.BaseGroup;

                        switch (this.selectedType) {
                            case 'emp':
                            case 'rec':
                                const selectedGroup = this.selectedList.find(i =>
                                    i.groupDTO.GroupID === rowId && i.groupDTO.BaseGroupType === baseGroup
                                );
                                selectedGroup.toAssign = false;

                                if (!this.assignList.some(i => i.GroupID === rowId && i.BaseGroupType === baseGroup))
                                    this.assignList.push(selectedGroup.groupDTO);

                                if (this.type === 'objectives') {
                                    const group = this.selectedList.find(i => i.groupDTO.GroupID === rowId).groupDTO;
                                    this.objectiveComponent.AssignToolGroupCountEvt(group);
                                }
                                break;
                            case 'attr':
                                const attr = this.selectedList.find(i => i.AttributeValueID === rowId);
                                attr.toAssign = false;

                                if(!this.assignList.some(i => i.AttributeValueID === rowId))
                                    this.assignList.push(attr);

                                break;
                            case 'login':
                                this.assignList.push(this.selectedList.find(i => i.groupDTO.GroupID === rowId).groupDTO);
                                break;
                        }
                    }
                }

                this.assignToolTable.updateRowData();
                this.assignToolTable.updateColumnDefs();
                this.assignToolTable.updateGridFilter();
            },

            //header checkbox change function
            doesExternalFilterPass: (node) => {
                const tmpFilter = this.assignToolTable.filterText.toUpperCase();

                switch (this.selectedType) {
                    case "emp":
                    case "rec":
                    case "attr":
                        if (this.assignList.length !== 0) {
                            const tempAgAssignList = this.assignList.filter(item => (
                                (item.AttributeValueName && item.AttributeValueName === node.data.Group) ||
                                (item.GroupName && item.GroupName === node.data.Group)
                            ))[0];

                            let hasToBeExcluded = false;
                            if (tempAgAssignList)
                                hasToBeExcluded = this.checkNodeHasToBeExcluded(node);

                            if (hasToBeExcluded) {
                                const filter = tempAgAssignList.AttributeValueName || tempAgAssignList.GroupName;
                                const groupUpper = node.data.Group.toUpperCase();
                                return groupUpper.includes(tmpFilter) && !groupUpper.includes(filter.toUpperCase());
                            }
                        }
                        return (node.data.Group && node.data.Group.toUpperCase().includes(tmpFilter));
                    case "login":
                        if (this.assignList.length !== 0) {
                            const tempAgAssignList = this.assignList.find(item => item.LoginName === node.data.LoginName);

                            if (tempAgAssignList != null) {
                                return ((node.data.Group && node.data.Group.toUpperCase().includes(tmpFilter)) &&
                                    !(node.data.Group && node.data.Group.toUpperCase().includes(tempAgAssignList.toUpperCase()))
                                );
                            }
                        }
                        return node.data.LoginName && node.data.LoginName.toUpperCase().includes(tmpFilter);
                }

                return true;
            },

            // Column check box change function to toggle the header column based on the column of check boxes
            setAllChecked: () => {
                if (this.disableContainers) return;

                if (this.selectedList.length > 0) {
                    const itemsToUpdate = [];

                    for (const displayRow of this.agGrid.api['rowModel'].rowsToDisplay) {
                        if (this.assignToolTable.doesExternalFilterPass(displayRow)) {

                            const data = displayRow.data;
                            data.chkbox = this.isCheckedAll;
                            data.toAssign = this.isCheckedAll;
                            itemsToUpdate.push(data);

                            const id = displayRow.id;
                            this.assignToolTable.centerTable.rowData[id] = cloneDeep(data);
                            this.selectedList[id].toAssign = this.isCheckedAll;
                        }
                    }

                    this.agGrid.api.applyTransaction({ update: itemsToUpdate });
                }
            },

            updateRowData: () => {
                if (!this.assignToolTable || !this.assignToolTable.centerTable || !this.agGrid?.api)
                    return;

                let itemsToUpdate = [];

                const assignToolTableData = this.assignToolTable.data.filter(gd =>
                    !this.assignList.some(al => al.GroupID === gd.GroupID || al.LoginID === gd.ID)
                );

                const filterFn = this.singleAdd ? this.isMatch : this.isMatchSimple

                itemsToUpdate = angular.copy(assignToolTableData.filter((d) => !this.assignList.some((al) => filterFn(al, d))));
                this.agGrid.api.setGridOption('rowData', itemsToUpdate);

                this.agGrid.api.redrawRows();
            },

            //pass the new value to the grid for filtering
            updateGridFilter: () => {
                if (this?.agGrid?.api)
                    this.agGrid.api.onFilterChanged();
                this.assignToolTable.updateOverlay();
            },

            updateOverlay: () => {
                if (this?.agGrid?.api) {
                    if (this.agGrid.api['filterManager'].rowModel.rowsToDisplay.length === 0) {
                        this.agGrid.api.showNoRowsOverlay();
                    } else {
                        this.agGrid.api.hideOverlay();
                    }
                }
            },

            // Empty search box
            clearSearch: () => {
                this.assignToolTable.filterText = "";
                this.assignToolTable.updateGridFilter();
                this.agGrid.api.onFilterChanged();
            },

            onRemove: (dto, login) => {
                if (dto == null) {
                    this.assignList = this.assignList.filter((l) => {
                        return l.LoginID != login.LoginID;
                    });
                }
                // Remove Group
                else {
                    this.assignList = this.assignList.filter((g) => {
                        if (g.GroupID !== undefined)
                            return g.GroupID != dto.GroupID || g.BaseGroupType != dto.BaseGroupType; // Groups
                        else
                            return g.AttributeValueID != dto.AttributeValueID; // Attributes
                    });

                    if (!this.singleAdd) {
                        let entry;
                        if (dto.GroupID || dto.BaseGroupType) {
                            entry = this.assignToolTable.centerTable.rowData.find(o => o.GroupID == dto.GroupID && o.BaseGroup == dto.BaseGroupType);
                        } else if (dto.AttributeValueID) { //Attributes
                            entry = this.assignToolTable.centerTable.rowData.find(o => o.GroupID == dto.AttributeValueID);
                        }
                        if (!!entry) {
                            entry.chkbox = '';
                            entry.toAssign = false;
                            this.selectedParticipants = this.selectedParticipants.filter(item => item.GroupID !== dto.GroupID);
                        }
                    }
                }

                if (this.type == "broadcast")
                    this.retainList = cloneDeep(this.assignList)

                this.assignToolTable.updateRowData();
                this.assignToolTable.updateColumnDefs();
                this.assignToolTable.updateGridFilter();
                this.singleRowSelected.emit(null); // Resetting the activeSelection in order to register onChanges
                this.activeSingleSelection = null;
            },

            // Single select button handler
            singleAssign: (row) => {
                if (this.disableContainers) return;

                if (!row || !row.entity || isNaN(row.entity.ID)) return;

                let selectedItem;
                let map = new Map(this.selectedList.map((selectedItem) => {
                    if (selectedItem.groupDTO)
                        return [selectedItem.groupDTO.GroupID, selectedItem] as [any, any];
                    else if (selectedItem.AttributeValueID)
                        return [selectedItem.AttributeValueID, selectedItem] as [any, any];
                    else
                        return [selectedItem.LoginID, selectedItem] as [any, any];
                }));
                if (this.selectedType == 'emp' || this.selectedType == 'rec') {
                    this.assignList.push(map.get(row.entity.ID).groupDTO);

                    // user admin
                    if (this.type == 'permission assignments') {
                        this.assignList[this.assignList.length - 1].name = this.assignList[this.assignList.length - 1].GroupName + " (" + this.selectedLabel + ")";
                    }

                    selectedItem = map.get(row.entity.ID).groupDTO;
                }
                else if (this.selectedType == 'attr' || this.selectedType === 'login') {
                    this.assignList.push(map.get(row.entity.ID));
                    selectedItem = map.get(row.entity.ID);
                }

                this.assignToolTable.updateRowData();
                this.singleRowSelected.emit(selectedItem);
                this.activeSingleSelection = selectedItem;
            },

            multiAssign: (row) => {
                if (this.disableContainers) return;

                const itemsToUpdate = [];
                row.toAssign = row.chkbox;

                this.selectedList[row.entity.ID].toAssign = row.chkbox;

                this.assignToolTable.centerTable.rowData[row.entity.ID].toAssign = row.chkbox;
                this.assignToolTable.centerTable.rowData[row.entity.ID].chkbox = row.chkbox;

                itemsToUpdate.push(row);
                this.agGrid.api.applyTransaction({ update: itemsToUpdate });

                const toAssign = this.assignToolTable.centerTable.rowData.filter((item) => !item.toAssign);
                this.isCheckedAll = toAssign.length == 0;
            },

            updateParentCol: () => {
                if (this.agGrid?.api != undefined) {
                    this.isCheckedAll = false;
                    this.agGrid.api.setGridOption('columnDefs', this.assignToolTable.setColumnDefs(true));

                    this.agGrid.api.setGridOption('rowData', this.assignToolTable.data);

                    //clean all selected assign in case setAllChecked function is not called
                    this.assignToolTable.centerTable.rowData = this.assignToolTable.centerTable.rowData?.map(data => {
                        return {
                            ...data,
                            chkbox: '',
                            toAssign: false,
                        }
                    });
                    this.assignToolTable.updateGridFilter();
                    this.assignToolTable.updateRowData();
                }
            },

            onAdd: (group, login, attr) => {
                let alreadyExists = false;
                if (group) {
                    // Make sure that the group doesn't already exist in the list
                    alreadyExists = this.assignList.filter((item) => {
                        return item.LoginID === undefined && item.GroupID === group.GroupID;
                    }).length > 0;

                    if (!alreadyExists)
                        this.assignList.push(group);
                }
                else if (attr) {
                    alreadyExists = this.assignList.filter((item) => {
                        return item.AttributeValueID == attr.AttributeValueID;
                    }).length > 0;

                    if (!alreadyExists)
                        this.assignList.push(attr);
                }
                else if (login) {
                    // Make sure that the login doesn't already exist in the list
                    alreadyExists = this.assignList.filter((item) => {
                        return item.LoginID === login.LoginID;
                    }).length > 0;

                    if (!alreadyExists)
                        this.assignList.push(login);
                }
            }
        };
    }

    public daMessager = (e, message) => {
        if (message.type == 'template') {
            this.daWarnings.showTemplateWarning = message.show;
        }

        if (message.type == 'write') {
            this.daWarnings.showWriteWarning = message.show;
        }

        if (message.type == 'readControl') {
            this.daWarnings.showReadControlWarning = message.show;
        }
    }

    public AssignToolUpdateRetainList = (event) => {
        if (this.retainSelected)
            this.retainList = angular.copy(this.assignList);
    }

    public AssignToolObjectiveSaveEvt = (data) => {
        let obj = {
            emp: [],
            rec: [],
            attr: [],
            coreAssignAtType: null,
            coreAssignAtLevel: 0,
            assignOptions: null,
            empAssignAll: data.empAssignAll,
            recAssignAll: data.recAssignAll
        };
        for (let listItem of data.list) {
            if (listItem.BaseGroupType == 0)
                obj.emp.push(listItem);
            else if (listItem.BaseGroupType == 1)
                obj.rec.push(listItem);
            else if (listItem.AttributeValueID != null)
                obj.attr.push(listItem);
        }

        obj.coreAssignAtType = data.type;
        obj.coreAssignAtLevel = data.lvl;

        if (this.dataTransfer != null && this.dataTransfer.assignOptions != null)
            obj.assignOptions = angular.copy(this.dataTransfer.assignOptions);

        if (!(data === undefined || data === null))
            this.dataTransfer = angular.copy(obj);

        if (this.retainSelected)
            this.retainList = angular.copy(this.assignList);

        this.dataTransferChange.emit(this.dataTransfer);

        this.closeClick();
    };

    public AssignToolWallboardSaveEvt = (event, dataList) => {
        this.assignToolService.saveWallboardChanges(this.dataTransfer.wallboardID, dataList);
        this.WallboardAssignmentUpdateLandingEvt.emit({ "wallboardID": this.dataTransfer.wallboardID, "dataList": dataList });
        this.closeClick();
    };

    removeEvent(dto) {
        var login = null;

        if (dto.login) {
            login = dto.login;
            dto = null;
        }

        this.assignToolTable.onRemove(dto, login);
    }

    public AssignToolCloseEvt = (event) => {
        this.closeClick();
    }

    //Just for games assign box
    public setList(groupList) {
        return cloneDeep(groupList);
    }

    private isMatch(al, d) {
        // If group
        if (typeof al?.GroupID != undefined && al.GroupID > 0)
            return al.GroupID === d.GroupID && al.BaseGroupType === d.BaseGroup;
        // If login
        else if (typeof al?.LoginID != undefined && al.LoginID > 0)
            return al.LoginID === d.GroupID;
        // If attribute
        else if (typeof al?.AttributeValueID != undefined && al.AttributeValueID > 0)
            return al.AttributeValueID === d.GroupID;
        else
            return false;
    }

    private isMatchSimple(al, d) {
        if (al.GroupID !== undefined) {
            return al.GroupID === d.GroupID && al.BaseGroupType === d.BaseGroup; //Group
        } else {
            return al.AttributeValueID === d.GroupID; //Attribute
        }
    }
}
